export const PLACE_SERVICE_FIELDS = [
  // @see https://developers.google.com/maps/documentation/javascript/place-data-fields
  'formatted_address',
  'address_components',
  'name',
  'place_id',
  'geometry.location',
];
